"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearLocalStorage = exports.authedFetch = exports.authedGet = exports.checkAuthFailed = exports.getAuthToken = void 0;
const tokens_1 = require("../config/tokens");
const platform_1 = require("./platform");
let authRefreshInterval = null;
function getAuthToken() {
    let token = window.localStorage.getItem(tokens_1.SESSION_TOKEN);
    if (token) {
        const expires = localStorage.getItem(tokens_1.SESSION_TOKEN_EXPIRY);
        if (expires !== null) {
            const timeLeft = new Date(expires).getTime() - new Date().getTime();
            if (timeLeft > 0) {
                return { success: true, token };
            }
            else {
                localStorage.removeItem(tokens_1.SESSION_TOKEN);
                return { success: false, error: 'Token expired' };
            }
        }
        else {
            return { success: true, token };
        }
    }
    else {
        return { success: false, error: 'No token found' };
    }
}
exports.getAuthToken = getAuthToken;
function authFailed() {
    if (authRefreshInterval) {
        clearInterval(authRefreshInterval);
        authRefreshInterval = null;
    }
    const apiUrl = (0, platform_1.getAPIUrl)();
    if (apiUrl) {
        window.location.href = `${apiUrl}/external-handover/init?site=${encodeURIComponent(window.location.href)}`;
    }
    else {
        alert('No session established, please login first.');
    }
}
function checkAuthFailed(jsonResponse) {
    return !!(jsonResponse === null || jsonResponse === void 0 ? void 0 : jsonResponse.authFailed);
}
exports.checkAuthFailed = checkAuthFailed;
function requireAuth() {
    return new Promise((resolve, reject) => {
        const token = getAuthToken();
        if (token.success && token.token) {
            resolve(token.token);
        }
        else {
            authFailed();
            reject(false);
        }
    });
}
function authedGet(url, params) {
    return authedFetchHelper('GET', url, params);
}
exports.authedGet = authedGet;
function authedFetch(url, params) {
    return authedFetchHelper('POST', url, params);
}
exports.authedFetch = authedFetch;
function authedFetchHelper(method, url, params) {
    return requireAuth().then(async function (authToken) {
        return await fetch((0, platform_1.getAPIUrl)() + url, {
            method: method,
            headers: {
                Authorization: `Bearer ${authToken}`,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: params ? JSON.stringify(params) : null,
        });
    });
}
function clearLocalStorage() {
    const { localStorage } = window;
    localStorage.removeItem(tokens_1.USERID_TOKEN);
    localStorage.removeItem(tokens_1.SESSION_TOKEN);
    localStorage.removeItem(tokens_1.SESSION_TOKEN_EXPIRY);
    console.log('Cleared storage');
}
exports.clearLocalStorage = clearLocalStorage;
